import type { JSX } from 'react';
import React, { useContext } from 'react';
import { useSearchParams } from 'react-router-dom';

import PageHeader from '@/components/PageHeader';
import TaskForm from '@/forms/TaskForm';
import PersonContext from '@/pages/Person/PersonContext';
import Container from '@/ui/components/Container';

const NewTask = (): JSX.Element | null => {
  const { person } = useContext(PersonContext);

  const [searchParams] = useSearchParams();

  let taskableId = searchParams.get('taskable_id');
  let taskableType = searchParams.get('taskable_type');
  const returnTo = searchParams.get('return_to');

  if (!taskableId || !taskableType) {
    taskableId = person.id;
    taskableType = 'people.person';
  }

  return (
    <Container type="page">
      <PageHeader headingText="New Task" />

      <TaskForm
        taskableId={taskableId}
        taskableType={taskableType}
        personId={person?.id}
        returnTo={returnTo}
      />
    </Container>
  );
};
export default React.memo(NewTask);
